export const styles = {
  fieldContainer: 'tw-grid tw-grid-cols-2 tw-gap-4',
  actionsContainer: 'tw-mt-6 tw-pt-4 tw-border-t tw-border-neutral-100',
};
